import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { Component } from 'react';
import { MAX_INT } from '../../../utils/number';
var CountdownTimer = /*#__PURE__*/function (_Component) {
  function CountdownTimer(props) {
    var _this;
    _classCallCheck(this, CountdownTimer);
    _this = _callSuper(this, CountdownTimer, [props]);
    _this.state = {
      timerBackgroundColor: 'green'
    };
    var justTimerText = props.justTimerText;
    var millisecondsRemaining = Math.abs(props.endDate - new Date());
    if (millisecondsRemaining > MAX_INT || justTimerText) {
      return _possibleConstructorReturn(_this);
    }
    var dangerThreshold = props.timerBackgroundThresholds.danger;
    var warnThreshold = props.timerBackgroundThresholds.warn;
    var initializeDangerTimeout = function initializeDangerTimeout() {
      setTimeout(function () {
        _this.setState({
          timerBackgroundColor: 'red'
        });
      }, millisecondsRemaining - dangerThreshold);
    };
    var initializeWarningTimeout = function initializeWarningTimeout() {
      setTimeout(function () {
        _this.setState({
          timerBackgroundColor: 'yellow'
        });
      }, millisecondsRemaining - warnThreshold);
    };
    if (millisecondsRemaining < dangerThreshold) {
      _this.state.timerBackgroundColor = 'red';
    } else if (millisecondsRemaining < warnThreshold) {
      _this.state.timerBackgroundColor = 'yellow';
      initializeDangerTimeout();
    } else {
      initializeDangerTimeout();
      initializeWarningTimeout();
    }
    return _this;
  }
  _inherits(CountdownTimer, _Component);
  return _createClass(CountdownTimer, [{
    key: "render",
    value: function render() {
      var justTimerText = this.props.justTimerText;
      return this.props.render({
        // Pass state and handlers to platform renderer
        timerBackgroundColor: this.state.timerBackgroundColor,
        justTimerText: justTimerText
      });
    }
  }]);
}(Component);
export { CountdownTimer as default };
CountdownTimer.defaultProps = {
  timerBackgroundThresholds: {
    warn: 12 * 60 * 60 * 1000,
    // Half Day
    danger: 1 * 60 * 60 * 1000 // 1 Hour
  }
};